/** The workflow used to establish a PLink for a task. */ export var PlanLinkOperationType = /*#__PURE__*/ function(PlanLinkOperationType) {
    /** Creates a new plan and connects it to the source task. */ PlanLinkOperationType["Create"] = "create";
    /** Connects an existing plan to the source task. */ PlanLinkOperationType["Connect"] = "connect";
    return PlanLinkOperationType;
}({});
/**
 * This enum represents the possible statuses for the creation of a plan link.
 */ export var PlanLinkCreationStatus = /*#__PURE__*/ function(PlanLinkCreationStatus) {
    // The plan link creation was successful.
    PlanLinkCreationStatus["Success"] = "success";
    // The plan link creation was cancelled.
    PlanLinkCreationStatus["Cancelled"] = "cancelled";
    // The plan link creation failed.
    PlanLinkCreationStatus["Failure"] = "failure";
    // The underlying plan creation failed and published its own error notification.
    PlanLinkCreationStatus["Failure_PlanCreationFailed"] = "failure-plan-creation-failed";
    // The plan link creation failed and could not fully clean up its changes.
    PlanLinkCreationStatus["Failure_CleanupFailed"] = "failure-cleanup-failed";
    // The plan link creation failed because the source task was not found.
    PlanLinkCreationStatus["Failure_SourceTaskNotFound"] = "failure-source-task-not-found";
    // The plan link creation failed because the source task update failed.
    PlanLinkCreationStatus["Failure_SourceTaskUpdateFailed"] = "failure-source-task-update-failed";
    return PlanLinkCreationStatus;
}({});
/**
 * This enum represents the possible statuses for connecting an existing plan to a task.
 */ export var PlanLinkConnectionStatus = /*#__PURE__*/ function(PlanLinkConnectionStatus) {
    // The existing plan was connected to the task successfully.
    PlanLinkConnectionStatus["Success"] = "connect-existing-plan-success";
    // The existing plan connection was cancelled.
    PlanLinkConnectionStatus["Cancelled"] = "cancelled";
    // The existing plan connection failed.
    PlanLinkConnectionStatus["Failure"] = "connect-existing-plan-failure";
    // The existing plan connection failed and could not fully clean up its changes.
    PlanLinkConnectionStatus["Failure_CleanupFailed"] = "connect-existing-plan-failure-cleanup-failed";
    // The existing plan connection failed because the source task was not found.
    PlanLinkConnectionStatus["Failure_SourceTaskNotFound"] = "connect-existing-plan-failure-source-task-not-found";
    // The existing plan connection failed because the source task update failed.
    PlanLinkConnectionStatus["Failure_SourceTaskUpdateFailed"] = "connect-existing-plan-failure-source-task-update-failed";
    return PlanLinkConnectionStatus;
}({});
/** Possible results for disconnecting a linked plan from a task. */ export var PlanLinkDisconnectionStatus = /*#__PURE__*/ function(PlanLinkDisconnectionStatus) {
    /** The reciprocal PLinks were removed successfully. */ PlanLinkDisconnectionStatus["Success"] = "disconnect-plan-success";
    /** The disconnection was cancelled. */ PlanLinkDisconnectionStatus["Cancelled"] = "cancelled";
    /** The operation failed before either PLink was removed. */ PlanLinkDisconnectionStatus["Failure"] = "disconnect-plan-failure";
    /** The plan backlink was removed, but the source task could not be updated. */ PlanLinkDisconnectionStatus["Failure_SourceTaskUpdateFailed"] = "disconnect-plan-failure-source-task-update-failed";
    /** The target plan could not be updated, so the source task was not changed. */ PlanLinkDisconnectionStatus["Failure_TargetPlanUpdateFailed"] = "disconnect-plan-failure-target-plan-update-failed";
    return PlanLinkDisconnectionStatus;
}({});
/** Shared engagement telemetry component name for Plink entry-point interactions. */ export const PlanLinkTelemetryComponentName = "PlanLink";
